<div class="cards-grid">
    @for (car of cars; track car.id) {
    <a class="car-card" [routerLink]="['vehicles', car.id]" (click)="onCardClick($event, car)">
        <!-- Image -->
        <div class="card-image">
            <img [src]="car.imageUrl" alt="car"
                (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
        </div>
        <!-- Body -->
        <div class="card-body">
            <!-- Plate + Status -->
            <div class="flex justify-content-between align-items-center mb-1">
                <span class="plate">{{ car.plateNo }}</span>
                <span class="status-badge"
                    [style.background]="getStatusStyle(car.status).background"
                    [style.color]="getStatusStyle(car.status).color">
                    <span class="status-dot" [style.background]="getStatusStyle(car.status).color"></span>
                    {{ car.status.replace('_', ' ') | titlecase }}
                </span>
            </div>
            <!-- Model -->
            <p class="model-name">{{ car.model.maker }} {{ car.model.name }}</p>
            <!-- Fuel -->
            <div class="bar-row">
                <span class="bar-label">Fuel</span>
                <div class="bar-track">
                    <div class="bar-fill"
                        [style.width.%]="getFuelPct(car)"
                        [style.background]="getProgressColor(getFuelPct(car))">
                    </div>
                </div>
                <span class="bar-value">{{ getFuelPct(car).toFixed(0) }}%</span>
            </div>

            <!-- Battery -->
            <div class="bar-row">
                <span class="bar-label">Battery</span>
                <div class="bar-track">
                    <div class="bar-fill"
                        [style.width.%]="getBatteryPct(car)"
                        [style.background]="getProgressColor(getBatteryPct(car))">
                    </div>
                </div>
                <span class="bar-value">{{ getBatteryPct(car).toFixed(0) }}%</span>
            </div>
            <!-- ID -->
            <p class="card-id">#{{ car.id }}</p>
        </div>
    </a>
    }

    @if (cars.length === 0) {
    <div class="no-data">No vehicles found</div>
    }
</div>

@if (cars.length > 0) {
<div class="cards-footer">
    <span class="footer-count">Showing {{ first + cars.length }} of {{ totalRecords }}</span>
    <p-paginator [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[20, 30, 50]" (onPageChange)="pageChange.emit($event)" />
</div>
}
